import React, { useState } from "react";
import Logo from '../../../assets/images/1.png';
import Profile from '../../../assets/images/profile-img.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faBell, faList, faEyeSlash, faEye } from "../../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import PDMC from '../../../assets/images/pdmc_logo.jpeg';
import $ from "jquery"
import './AdminSideBar'
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useEffect } from "react";
const AdminHeaderNature = () => {
  const navigate = useNavigate()
  const [labelData, setLabelData] = useState("");
  const [oldPassword, setOldPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmNewPassword, setConfirmNewPassword] = useState("")
  const [passwordShown1, setPasswordShown1] = useState(false);
  const [passwordShown2, setPasswordShown2] = useState(false);
  const [passwordShown3, setPasswordShown3] = useState(false);
    const [sessionData, setSessionData] = useState({});

  // Helper function to get mobile number from sessionStorage
  const getMobileNumber = () => {
    return sessionStorage.getItem("mobileno") || 
           sessionStorage.getItem("userMobile") || 
           sessionStorage.getItem("mobileNo") || 
           sessionStorage.getItem("mobile") || "";
  };
//alert(sessionStorage.getItem("mobileno"))
  // Helper function to get user ID from sessionStorage
  const getUserId = () => {
    return sessionStorage.getItem("userCodeModel") || 
           sessionStorage.getItem("userId") || 
           sessionStorage.getItem("userCode") || "";
  };

  // const[flag, setFlag] = useState(false);

  function mySidebarToggle() {
    var element = document.getElementById("myDIV");
    element.classList.toggle("mystyle");
    var element2 = document.getElementById("main");
    element2.classList.toggle("fullDiv");
  }

  useEffect(() => {
    const data = {};
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      data[key] = sessionStorage.getItem(key);
    }
   
    setSessionData(data);
  }, []);


  useEffect(() => {
    //alert(sessionStorage.getItem("userMobile"));
    //alert(sessionStorage.getItem("schemeCodeModel"));
    let userNameLocal = sessionStorage.getItem("userNameModel");
    let schemeCode = sessionStorage.getItem("schemeCodeModel");
    let userNameModify = userNameLocal.charAt(0).toUpperCase() + userNameLocal.slice(1)
    //document.getElementById("username").innerHTML = userNameModify;
    document.getElementById("usernameModel").innerHTML = userNameModify;
    if (sessionStorage.getItem("schemeCodeModel") === "1") {
      document.getElementById("heading_model").innerHTML = "PDMC";

    } else if (sessionStorage.getItem("schemeCodeModel") === "2") {
      document.getElementById("heading_model").innerHTML = "RAD";

    } else if (sessionStorage.getItem("schemeCodeModel") === "3") {
      document.getElementById("heading_model").innerHTML = "AgroForestory";

    }

    else if (sessionStorage.getItem("schemeCodeModel") === "4") {
      document.getElementById("heading_model").innerHTML = "Seed Distribution";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "5") {
      document.getElementById("heading_model").innerHTML = "National Mission on Edible Oils -OS ";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "6") {
      document.getElementById("heading_model").innerHTML = "Natural Farming";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "7") {
      document.getElementById("heading_model").innerHTML = "National Beekeeping and Honey Mission ";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "8") {
      document.getElementById("heading_model").innerHTML = "Mission for Integrated Development of Horticulture";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "9") {
      document.getElementById("heading_model").innerHTML = "Mission Organic Value Chain Development";

    } else if (sessionStorage.getItem("schemeCodeModel") === "10") {
      document.getElementById("heading_model").innerHTML = "Coconut Development Board";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "11") {
      document.getElementById("heading_model").innerHTML = "Directorate of Arecanut and Spices Development";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "12") {
      document.getElementById("heading_model").innerHTML = "Ground Truthing";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "13") {
      document.getElementById("heading_model").innerHTML = "Crop Condition";

    } else if (sessionStorage.getItem("schemeCodeModel") === "15") {
      document.getElementById("heading_model").innerHTML = "RKVY DPR";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "16") {
      document.getElementById("heading_model").innerHTML = "M&T";

    }
    else if (sessionStorage.getItem("schemeCodeModel") === "20") {
      document.getElementById("heading_model").innerHTML = "ATMA";

    }
    
    
  }, [])

  //alert(sessionStorage.getItem("mobileno"));
  function handleChangePassword() {
    console.log("Change Password clicked for scheme code:", sessionStorage.getItem("schemeCodeModel"));
    console.log("Password values:", { oldPassword, newPassword, confirmNewPassword });

    // Validation checks
    if (!oldPassword || oldPassword.trim() === "") {
      alert("Please enter your old password");
      return;
    }
    
    if (!newPassword || newPassword.trim() === "") {
      alert("Please enter a new password");
      return;
    }
    
    if (!confirmNewPassword || confirmNewPassword.trim() === "") {
      alert("Please confirm your new password");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      alert("New Password and Confirm Password does not match");
      return;
    }
    
    if (newPassword.length < 6) {
      alert("New password must be at least 6 characters long");
      return;
    }
    if (sessionStorage.getItem("schemeCodeModel") === "12" || sessionStorage.getItem("schemeCodeModel") === "13") {
      axios
        .post(
          `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
          }/api/GT/Users/changePassword`,
          {
            modifiedByUC: sessionStorage.getItem("userCodeModel"),
            userCode: sessionStorage.getItem("userCodeModel"),
            password: oldPassword,
            passwordNew: newPassword,
            passwordConfirm: confirmNewPassword,

          }
        )
        .then(function (response) {
          alert(response.data.message);
          if (response.data.success) {
            // $("#modal").modal('hide');
            $('#changeBtn').on('click', function () {
              $('#changePasswordModel').modal('hide');
            })
            setOldPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
            navigate("/login");
          }
        })
        .catch(function (error) {
          console.log(error);
        });

    }
    //Rupali
    else if (sessionStorage.getItem("schemeCodeModel") === "5" ) {
      axios
        .post(
          `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
          }/api/NMEOSUsers/NMEOScommchangePassword`,
          {
            modifiedByUC: sessionStorage.getItem("userCodeModel"),
            userCode: sessionStorage.getItem("userCodeModel"),
            password: oldPassword,
            passwordNew: newPassword,
            passwordConfirm: confirmNewPassword,

          }
        )
        .then(function (response) {
          alert(response.data.message);
          if (response.data.success) {
            // $("#modal").modal('hide');
            $('#changeBtn').on('click', function () {
              $('#changePasswordModel').modal('hide');
            })
            setOldPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
            navigate("/login");
          }
        })
        .catch(function (error) {
          console.log(error);
        });

    }
    
    else if (sessionStorage.getItem("schemeCodeModel") === "16" ) {
      console.log("Processing scheme code 16 - M&T password change");
      console.log("API URL:", `${process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE
      }/api/MT/ChangeUserPass`);
      
      // Get mobile number using helper function
      const mobileNumber = getMobileNumber();
      
      console.log("Request data:", {
        userId: sessionStorage.getItem("userCodeModel"),
        oldPassword: oldPassword,
        newPassword: newPassword,
        userRoleCode: parseInt(sessionStorage.getItem("userRoleCodeModel")),
        userTypeCode: parseInt(sessionStorage.getItem("userTypeCodeModel")),
        userCode: parseInt(sessionStorage.getItem("userCodeModel"))
      });
      
      // Validate that required fields are not empty and convert to numbers
      const userId = sessionStorage.getItem("userCodeModel");
      const userRoleCodeStr = sessionStorage.getItem("userRoleCodeModel");
      const userTypeCodeStr = sessionStorage.getItem("userTypeCodeModel");
      
      if (!userId || !userRoleCodeStr || !userTypeCodeStr) {
        alert("Error: Missing user information. Please login again.");
        console.error("Missing session data:", { userId, userRoleCodeStr, userTypeCodeStr });
        return;
      }
    
      // Ensure numeric values are valid before making API call
      const userRoleCode = parseInt(userRoleCodeStr);
      const userTypeCode = parseInt(userTypeCodeStr);
      const userCode = parseInt(userId);
      
      if (isNaN(userRoleCode) || isNaN(userTypeCode) || isNaN(userCode)) {
        alert("Error: Invalid user data. Please login again.");
        console.error("Invalid numeric values:", { userRoleCode, userTypeCode, userCode });
        return;
      }
      
      axios
        .post(
          `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
          }/api/MT/ChangeUserPass`,
          {
            userId: sessionStorage.getItem("mobile"),
            oldPassword: oldPassword,
            newPassword: newPassword,
            userRoleCode: userRoleCode,
            userTypeCode: userTypeCode,
            userCode: userCode
          }
        )
        .then(function (response) {
          console.log("M&T API Response:", response.data);
          console.log("Response success:", response.data.success);
          console.log("Response message:", response.data.message);
          if (response.data.dataContent && response.data.dataContent.length > 0) {
            console.log("DataContent:", response.data.dataContent[0]);
          }
          
          // Handle M&T API response structure
          if (response.data && response.data.success) {
            // Check if we have dataContent with status
            if (response.data.dataContent && response.data.dataContent.length > 0) {
              const dataContent = response.data.dataContent[0];
              
              if (dataContent.status === "1") {
                // Success case
                console.log("Password change successful - status is 1");
                alert("Password updated successfully.");
                navigate("/login");
                // Clear form fields first
                setOldPassword("");
                setNewPassword("");
                setConfirmNewPassword("");
                
                // Hide modal
                $('#changePasswordModel').modal('hide');
                
                // Navigate after a small delay to ensure modal is closed
                setTimeout(() => {
                  console.log("Navigating to login page");
                  navigate("/login");
                }, 500);
              } else {
                // Failure case from dataContent
                alert(dataContent.message || "Password change failed. Please try again.");
              }
            } else {
              // Success case without dataContent
              console.log("Password change successful - no dataContent");
              alert("Password updated successfully.");
              navigate("/login");
              // Clear form fields first
              setOldPassword("");
              setNewPassword("");
              setConfirmNewPassword("");
              
              // Hide modal
              $('#changePasswordModel').modal('hide');
              
              // Navigate after a small delay to ensure modal is closed
              setTimeout(() => {
                console.log("Navigating to login page (no dataContent case)");
                navigate("/login");
              }, 500);
            }
          } else {
            // Failure case - API returned success: false
            alert(response.data.message || "Password change failed. Please try again.");
          }
        })
       .catch(function (error) {
          console.log(error);
        });
    }
    //Rupali
    else {
      axios
        .post(
          `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
          }/api/Management/CommUsers/commchangePassword`,
          {
            modifiedByUC: sessionStorage.getItem("userCodeModel"),
            userCode: sessionStorage.getItem("userCodeModel"),
            password: oldPassword,
            passwordNew: newPassword,
            passwordConfirm: confirmNewPassword,

          }
        )
        .then(function (response) {
          alert(response.data.message);
          if (response.data.success) {
            // $("#modal").modal('hide');
            $('#changeBtn').on('click', function () {
              $('#changePasswordModel').modal('hide');
            })
            setOldPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
            navigate("/login");
          }
        })
        .catch(function (error) {
          console.log(error);
        });

    }
  }

  function handleResetValue() {
    setOldPassword("")
    setNewPassword("")
    setConfirmNewPassword("")
    setPasswordShown1(false)
    setPasswordShown2(false)
    setPasswordShown3(false)
  }

  function handleLogout() {
    // Clear all session storage
    sessionStorage.clear();
    // Navigate to login page
    navigate("/");
  }

  return (
    <>
      <div id="header" className="header fixed-top d-flex align-items-center">
        <div className="d-flex align-items-center justify-content-between">
          <i className="toggle-sidebar-btn"><FontAwesomeIcon icon={faBars} onClick={mySidebarToggle} /></i>

          {/* <a href="/" className="logo d-flex align-items-center innerLogo">
                     <img src={NaturalFarming}/></a> */}
          {/* <Link
              to="/nature/dashboard"
              className="logo d-flex align-items-center innerLogo"
            >
              <img src={PDMC} style={{ width: "180px" }} />
            </Link> */}


          

          <h3 id="heading_model">{sessionStorage.getItem("currentSchemeName")}</h3>
        </div>


        <div className="header-nav ms-auto">
          <ul className="d-flex align-items-center">
            <li className="nav-item dropdown pe-3">
              <a className="nav-link nav-profile d-flex align-items-center pe-0" data-bs-toggle="dropdown">
                <img src={Profile} alt="Profile" className="rounded-circle" />
            
                <div className="statename d-none d-md-block dropdown-toggle ps-2" id="username">
  {
   sessionStorage.getItem("schemeCodeModel") === "16" ? (
      sessionStorage.getItem("userRoleCodeModel") === "1" ? "Central Admin" :
      sessionStorage.getItem("userRoleCodeModel") === "2" ? "State" :
      sessionStorage.getItem("userRoleCodeModel") === "3" ? "District" :
      sessionStorage.getItem("userRoleCodeModel") === "5" ? "Surveyor" :
      sessionStorage.getItem("userRoleCodeModel") === "6" ? "FMTTI" :
      sessionStorage.getItem("userRoleCodeModel") === "7" ? "FMTC" :
      sessionStorage.getItem("userRoleCodeModel") === "8" ? "Surveyor" :
      sessionStorage.getItem("userRoleCodeModel") === "9" ? "ICAR" :
      sessionStorage.getItem("userRoleCodeModel") === "10" ? "Atari" :
      sessionStorage.getItem("userRoleCodeModel") === "11" ? "KVK" :
      sessionStorage.getItem("userRoleCodeModel") === "12" ? "Surveyor" :
      ""
    ) : (
      sessionStorage.getItem("userTypeCodeModel") === "1" ? "Central Admin" :
      sessionStorage.getItem("userTypeCodeModel") === "2" ? "State Admin" :
      sessionStorage.getItem("userTypeCodeModel") === "3" ? "District Admin" :
      sessionStorage.getItem("userTypeCodeModel") === "4" && sessionStorage.getItem("schemeCodeModel") === "5" ? "VCP Admin" :
      sessionStorage.getItem("userTypeCodeModel") === "4" ? "Sub District Admin" :
      sessionStorage.getItem("userTypeCodeModel") === "5" ? "Surveyor" :
      sessionStorage.getItem("userTypeCodeModel") === "6" ? "Sakhi" :
      ""
    )
  }
</div>

              </a>
              <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
  
                <li className="dropdown-header">
                  <a className="dropdown-item d-flex align-items-center" href="#">
                    <i className="bi bi-person-bounding-box"></i>
                    <span id="usernameModel"></span>
                  </a>
                </li>
                <li>
                  <span
                    type="button" className="dropdown-item d-flex btn-info"
                    data-bs-toggle="modal" data-bs-target="#changePasswordModel"
                  >
                  <i className="bi bi-pencil-square"></i>
                    Change Password
                  </span>
                </li>
                <li>
                  <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right"></i>
                    <span><strong>Sign Out</strong></span>
                  </a>
                </li>

              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div className="modal" id="changePasswordModel">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <strong>Change Password</strong>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={handleResetValue}
              >X</button>
            </div>
            <div className="modal-body">
              {/* <label for="add_season" className="form-label">
                Add New User Type
              </label> */}
              Old Password
              <div className="input-group ">
                <input
                  type={passwordShown1 ? "text" : "password"}
                  className="form-control"

                  // placeholder="Old Password "
                  onChange={(e) => setOldPassword(e.target.value)}
                  value={oldPassword}
                />
                <i className="flex justify-around items-center showhidebtns" onClick={() => setPasswordShown1(!passwordShown1)}>
                  <FontAwesomeIcon icon={passwordShown1 ? faEyeSlash : faEye} />
                </i>{" "}
              </div>
              New Password
              <div className="input-group">

                <input
                  type={passwordShown2 ? "text" : "password"}
                  className="form-control"
                  // placeholder="New Password"
                  onChange={(e) => setNewPassword(e.target.value)}
                  value={newPassword}
                />
                <i className="flex justify-around items-center showhidebtns" onClick={() => setPasswordShown2(!passwordShown2)}>
                  <FontAwesomeIcon icon={passwordShown2 ? faEyeSlash : faEye} />
                </i>{" "}
              </div>
              Confirm New Password
              <div className="input-group">
                <input
                  type={passwordShown3 ? "text" : "password"}
                  className="form-control"
                  // placeholder="Confirm New Password"
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  value={confirmNewPassword}
                />
                <i className="flex justify-around items-center showhidebtns" onClick={() => setPasswordShown3(!passwordShown3)}>
                  <FontAwesomeIcon icon={passwordShown3 ? faEyeSlash : faEye} />
                </i>{" "}
              </div>

            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                id="changeBtn"
                //  data-bs-dismiss="modal"
                onClick={handleChangePassword}
              >
                Change
              </button>
              <button
                type="button"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={handleResetValue}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>

  )

}

export default AdminHeaderNature